// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const QrCode: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve">
<g fill="currentColor">
	<path d="M18.57,5.43H12.6v5.98h5.98V5.43z M17.38,10.21h-3.59V6.62h3.59V10.21z"/>
	<path d="M5.43,18.57h5.98V12.6H5.43V18.57z M6.62,13.79h3.59v3.59H6.62V13.79z"/>
	<rect x="12.6" y="16.18" width="2.39" height="2.39"/>
	<polygon points="16.18,18.57 18.57,18.57 18.57,16.18 18.57,14.99 14.99,14.99 14.99,16.18 16.18,16.18 	"/>
	<path d="M5.43,11.4h5.98V5.43H5.43V11.4z M6.62,6.62h3.59v3.59H6.62V6.62z"/>
	<rect x="12.6" y="12.6" width="2.39" height="2.39"/>
	<polygon points="3.14,3.14 9.01,3.14 9.01,1.74 1.74,1.74 1.74,9.01 3.14,9.01 	"/>
	<polygon points="14.99,1.74 14.99,3.14 20.86,3.14 20.86,9.01 22.26,9.01 22.26,1.74 	"/>
	<polygon points="20.86,20.86 14.99,20.86 14.99,22.26 22.26,22.26 22.26,14.99 20.86,14.99 	"/>
	<polygon points="3.14,14.99 1.74,14.99 1.74,22.26 9.01,22.26 9.01,20.86 3.14,20.86 	"/>
</g>
</svg>;
};

export default React.memo(QrCode);
